import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, ConnectedProps } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { WithStyles, withStyles, IconButton, Badge } from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";

import { styles } from "./NotificacionesStyles";
import Notificacion from "./Notificacion/Notificacion";
import * as actionCreators from "../../store/actions";

const mapStateToProps = (state: any) => ({
  comunicaciones: state.comunicaciones.comunicaciones,
});

const mapDispatchToProps = (dispatch: any) => ({
  setCurrentCommunication: (current: any) =>
    dispatch(actionCreators.setCurrentCommunication(current)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & WithStyles<typeof styles>;

const Notificaciones: React.FC<Props> = (props: any) => {
  const { classes, comunicaciones, setCurrentCommunication } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const verTodasComunicacionesClicked = () => {
    navigate("/comunicaciones");
    setCurrentCommunication(null);
    setAnchorEl(null);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const communicationClickedHandler = (communication: any) => {
    setCurrentCommunication(communication);
    setAnchorEl(null);
    navigate("/comunicaciones");
  };

  const esEmailSinLeer = (comunicacion: any) =>
    comunicacion.tipo === "EMAIL" && comunicacion.leidoPortal === "N";

  const existeComunicacionSinLeer = comunicaciones.some(esEmailSinLeer);

  const listaNotificaciones = existeComunicacionSinLeer ? (
    comunicaciones
      .filter(esEmailSinLeer)
      .slice(0, 5)
      .map((comunicacion: any) => {
        return (
          <MenuItem
            key={comunicacion.id}
            onClick={() => communicationClickedHandler(comunicacion)}
          >
            <Notificacion
              fecha={comunicacion.fecha.split(" ", 1)[0]}
              asunto={comunicacion.asunto}
            />
          </MenuItem>
        );
      })
  ) : (
    <div className={classes.sinNotificacion}>
      <p>No tienes nuevas comunicaciones</p>
    </div>
  );

  const campanaConNotificaciones = () => {
    const cantidad = comunicaciones.filter(esEmailSinLeer).length;
    return (
      <Badge className={classes.badge} color="error" badgeContent={cantidad}>
        <NotificationsIcon
          style={{
            color: "white",
            backgroundImage: "linear-gradient(278deg, #4aa9d8, #1779c0)",
          }}
        />
      </Badge>
    );
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        className={classes.btnShadowNone}
        aria-label="Comunicaciones sin leer"
      >
        {existeComunicacionSinLeer ? (
          campanaConNotificaciones()
        ) : (
          <NotificationsNoneIcon style={{ color: "#C1C1C1" }} />
        )}
      </IconButton>

      <Menu
        id="menu-notificaciones"
        className={classes.menu}
        elevation={0}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        onMouseLeave={() => setAnchorEl(null)}
      >
        <MenuItem>
          <h4>Comunicaciones</h4>
        </MenuItem>
        {listaNotificaciones}
        <MenuItem>
          <Button
            className={classes.btnVerTodas}
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => verTodasComunicacionesClicked()}
          >
            Ver todas
          </Button>
        </MenuItem>
      </Menu>
    </>
  );
};

export default connector(
  withStyles(styles)(Notificaciones)
) as React.ComponentType;
